
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/kayzen",
      function () {
        return require("private-next-pages/destinations/kayzen.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/kayzen"])
      });
    }
  